import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styles from '../../styles/components/common/CollapsibleSection.module.css';

const CollapsibleSection = ({
  title,
  subtitle,
  children,
  defaultExpanded = true,
  className = '',
  titleIcon,
  variant = 'default', // 'default', 'danger'
  fieldsLayout = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const sectionClass = `${styles.collapsibleSection} ${styles[variant]} ${className}`.trim();
  const headerClass = `${styles.sectionHeader} ${isExpanded ? styles.expanded : styles.collapsed}`;

  return (
    <div className={sectionClass}>
      <button
        type="button"
        className={headerClass}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <div className={styles.titleContent}>
          {titleIcon && (
            <span className={styles.titleIcon}>
              {titleIcon}
            </span>
          )}
          <div className={styles.titleText}>
            <h3 className={styles.sectionTitle}>{title}</h3>
            {subtitle && <p className={styles.sectionSubtitle}>{subtitle}</p>}
          </div>
        </div>
        <div className={styles.toggleIcon}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </div>
      </button>

      <div
        className={`${styles.sectionContent} ${isExpanded ? styles.expanded : styles.collapsed} ${fieldsLayout ? styles.fieldsLayout : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;